import ClosePositionModal from "../../ConfirmationModal/ClosePositionModal";
import WithdrawModal from "../../DepositWithdrawModal/WithdrawModal";
import OneClickToggle from "../../OneClickTrading/OneClickToggle";
import { ContentWrapper, DetailsWrapper, FormContent, TradeForm } from "../style";
import PerpsTradeFormTopSection from "./PerpsTradeForm.TopSection";
import PerpsTradeFormOrderInputs from "./PerpsTradeForm.OrderInputs";
import PerpsTradeFormExtras from "./PerpsTradeForm.Extras";
import PerpsTradeFormSubmitSection from "./PerpsTradeForm.SubmitSection";
import PerpsTradeFormAccountEquity from "./PerpsTradeForm.AccountEquity";
import { PerpsTradeFormCtx } from "./PerpsTradeForm.ctx";

export default function PerpsTradeFormView({
  ctx,
}: {
  ctx: PerpsTradeFormCtx;
}) {
  const {
    modalRef,
    mobileMode,
    handleSubmit,
    isSpot,
    submitSpotOrder,
    submitOrder,
    isPerp,
    showClosePositionModal,
    currentPosition,
    onCloseModalHide,
    showWithdrawModal,
    setShowWithdrawModal,
    accountData,
  } = ctx;

  return (
    <ContentWrapper ref={modalRef} isMobile={mobileMode} style={{ bottom: 0 }}>
      <TradeForm
        data-trade-form
        onSubmit={handleSubmit(isSpot ? submitSpotOrder : submitOrder)}
      >
        {isPerp && showClosePositionModal && (
          <ClosePositionModal
            position={currentPosition}
            onHide={onCloseModalHide}
            show={showClosePositionModal}
          />
        )}
        {showWithdrawModal && (
          <WithdrawModal
            show={showWithdrawModal}
            // Without it the modal had no balances: both rows read "---" and
            // Max always filled 0.
            accountData={accountData}
            onHide={() => setShowWithdrawModal(false)}
          />
        )}
        <FormContent>
          <PerpsTradeFormTopSection ctx={ctx} />
          <DetailsWrapper>
            <PerpsTradeFormOrderInputs ctx={ctx} />
            <PerpsTradeFormExtras ctx={ctx} />
          </DetailsWrapper>

          {/* ── One-click (session-key) trading toggle — perps + spot ──
              The shared AgentRegistry means one approval authorizes both engines, and
              useSpotOrder already signs gaslessly with the agent key, so the toggle
              belongs on the spot form too. It self-hides when one-click is unsupported. */}
          <OneClickToggle />

          {/* ── Place Order / Enable Trading button ── */}
          <PerpsTradeFormSubmitSection ctx={ctx} />

          <PerpsTradeFormAccountEquity ctx={ctx} />
        </FormContent>
      </TradeForm>
    </ContentWrapper>
  );
}
